export default __webpack_public_path__ + "static/media/eyecare.5e140ffe.jpg";